// Central, editable network data — add / remove / update destinations here.
// Status: "priority" = prioritary destination market, "target" = potential destination market under evaluation.
// These are illustrative market positions, NOT confirmed routes, offices, clients or active operations.

export const ORIGIN = { id: "dubai", lon: 55.27, lat: 25.2 };

export const DESTINATIONS = [
  // Europe — priority
  { id: "barcelona", lon: 2.17, lat: 41.38, status: "priority" },
  { id: "valencia", lon: -0.37, lat: 39.47, status: "priority" },
  { id: "madrid", lon: -3.7, lat: 40.42, status: "priority" },
  { id: "monaco", lon: 7.42, lat: 43.74, status: "priority" },
  { id: "london", lon: -0.13, lat: 51.51, status: "priority" },
  { id: "paris", lon: 2.35, lat: 48.86, status: "priority" },
  { id: "milan", lon: 9.19, lat: 45.46, status: "priority" },
  { id: "frankfurt", lon: 8.68, lat: 50.11, status: "priority" },
  { id: "geneva", lon: 6.14, lat: 46.2, status: "priority" },
  // Asia
  { id: "shanghai", lon: 121.47, lat: 31.23, status: "target" },
  { id: "hongkong", lon: 114.17, lat: 22.32, status: "target" },
  { id: "singapore", lon: 103.82, lat: 1.35, status: "target" },
  { id: "tokyo", lon: 139.69, lat: 35.68, status: "target" },
  { id: "seoul", lon: 126.98, lat: 37.57, status: "target" },
  // North America
  { id: "newyork", lon: -74.0, lat: 40.71, status: "target" },
  { id: "miami", lon: -80.19, lat: 25.76, status: "target" },
  { id: "losangeles", lon: -118.24, lat: 34.05, status: "target" },
  { id: "toronto", lon: -79.38, lat: 43.65, status: "target" },
  { id: "mexicocity", lon: -99.13, lat: 19.43, status: "target" },
  // Central & South America
  { id: "panama", lon: -79.52, lat: 8.98, status: "target" },
  { id: "saopaulo", lon: -46.63, lat: -23.55, status: "target" },
  { id: "buenosaires", lon: -58.38, lat: -34.6, status: "target" },
  // Africa
  { id: "casablanca", lon: -7.59, lat: 33.57, status: "target" },
  { id: "johannesburg", lon: 28.05, lat: -26.2, status: "target" },
  // Oceania
  { id: "sydney", lon: 151.21, lat: -33.87, status: "target" },
];

export const ALL_NODES = [ORIGIN, ...DESTINATIONS];
